import FormattedMessage from 'I18n/components/FormattedMessage';
import { SuccessIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnMoreModalListItem = ({
  children,
  message
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: SuccessIcon,
      marginInlineEnd: "200",
      paddingBlockStart: "50",
      size: "400"
    }), message ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }) : children]
  });
};
export default LearnMoreModalListItem;